import styles from '../selected-combination.module.css';

import { ItemsByCountry } from '../../../store/useDiagramStore';
import {
    Asset,
    InvestmentFund,
    Investor,
    SelectionLevel,
    SelectionLevelProps,
    TCountryCode,
} from '../../../types/general';
import { Checkbox, Icon } from '../../index';
import { SelectedItem } from '../../SelectionPopup/SelectionPopup';
import React from 'react';
import SelectionLabel from '../../SelectionLabel/SelectionLabel';

interface SelectionCombinationRowProps {
    items: ItemsByCountry<Investor> | ItemsByCountry<Asset> | ItemsByCountry<InvestmentFund>;
    itemId: number | null | undefined | SelectedItem[] | SelectedItem[];
    type: SelectionLevel;
    selectedCountry?: TCountryCode | null;
    selectedData?: any;
    name?: string;
    isSelectable?: boolean;
    handleSelectedInvestor?: any;
}

const SelectionCombinationRow = ({
    items,
    itemId,
    type,
    selectedData,
    name,
    isSelectable,
    handleSelectedInvestor,
    selectedCountry,
}: SelectionCombinationRowProps) => {
    const findById = (id: number) =>
        items &&
        // @ts-ignore
        items[selectedCountry]?.find((i) => +i[SelectionLevelProps[type].valueKey] === +id)?.[
            SelectionLevelProps[type].labelKey
        ];

    return (
        <>
            <div>
                {itemId && (
                    <>
                        <SelectionLabel type={type} />
                        <div>
                            <div className={styles.block}>
                                {selectedCountry?.toUpperCase() || ' '}{' '}
                                {typeof itemId === 'object'
                                    ? itemId.map((item, i) => (
                                          <div key={i} className={styles.proposedCheck}>
                                              {isSelectable ? (
                                                  <Checkbox
                                                      type={'radio'}
                                                      name={type}
                                                      // className={`${styles.selectableItem} ${
                                                      //     selectedData.selectedInvestor?.id === item.id
                                                      //         ? styles.selected
                                                      //         : ''
                                                      // }`}
                                                      checked={selectedData.selectedInvestor?.id === item.id}
                                                      value={item.id?.toString() || ''}
                                                      disabled={selectedData.investors.length === 1}
                                                      onChange={handleSelectedInvestor(item.id!)}
                                                      label={`${item.countryCode?.toUpperCase()} ${item.name}`}
                                                      useMargin={false}
                                                  ></Checkbox>
                                              ) : (
                                                  <span
                                                      style={{
                                                          display: 'block',
                                                          // marginBottom: '10px',
                                                          // color:
                                                          //     item.id === selectedData?.selectedInvestor?.id
                                                          //         ? '#1650B4'
                                                          //         : undefined,
                                                      }}
                                                  >
                                                      {item.countryCode?.toUpperCase()} {item.name}
                                                  </span>
                                              )}
                                          </div>
                                      ))
                                    : name || findById(+itemId)}
                            </div>
                        </div>
                    </>
                )}
            </div>
        </>
    );
};

export default SelectionCombinationRow;
